var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"j-text-field",attrs:{"color":_vm.color,"outlined":"","rounded":"","pattern":_vm.pattern,"maxlength":_vm.maxlength}},'v-text-field',[_vm.$props, _vm.$attrs],false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }